<template lang="html">
  
  <div>
    <div class="columns is-multiline is-1" v-bind:id="id" >
      <div class="column" v-bind:class="{'is-half':config.dual,'is-full':!config.dual}" v-for="(field, index) in fields" v-bind:key="field.name">
        <bulmaFieldInternalStore v-if="field.name" v-bind:id="field.name" v-bind:data="field" v-bind:table="config.table" v-bind:readonly="field.readonly" v-bind:record="record" v-on:change="bubbleUpChange($event)"></bulmaFieldInternalStore>
        
        <div class="field is-horizontal" v-bind:id="id" v-if="field.blank">
          <div class="field-label is-small">
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control is-small">
              </div>
            </div>
          </div>
        </div>
        
        <div class="field is-horizontal" v-bind:id="id" v-if="field.isGoogleAutocomplete && !disabled">
          <div class="field-label is-small">
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control is-small" v-bind:id="id+'isGoogleAutocomplete'">
              </div>
            </div>
          </div>
        </div>
        
      </div>
      
      
    </div>
  </div>
  
  
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader"

export default {
  name: 'bulmaFieldSetInternalStore',
  components: {},

  props: {
    id: String,
    recordid: String,
    stepprops: Object,
    record: Object
  },
  
  data: function () {
    return {
      showModal: false,
      place: {}
    }
  },

  watch: {
    disabled: function(newVal) {
      if (!newVal) {
        if (this.config && this.config.apiKey) this.googleAutocomplete();
      }
    }
  },

  computed: {
    invalid: function() {
      let invalid=false;
      let r=this.record;
      this.fields.forEach( (f) => {
        let fval=this.getFieldValue(r, f.name);
        if (f.required && !fval) invalid=true;
      })
      return invalid;
    },
    fields: function () {
      if (!this.$store.state.database.has(this.table)) return [];
      let table=this.$store.state.database.get(this.table);
      let solvedfields=[]
      this.stepprops.recordFields.forEach( f => {
        if (f.isBlank || f.isGoogleAutocomplete) {
          solvedfields.push((f));
        }
        if (table.has(f.fieldname)) {
          if(table.get(f.fieldname).type != 'hidden') {
            let f2={ ...table.get(f.fieldname) }
            if (f.readonly) f2.readonly=f.readonly;
            if (f.required) f2.required=f.required;
            if (f.success) f2.success=f.success;
            solvedfields.push( f2 );
          }
        }
      });
      return solvedfields;
    },
    config: function () {
      if (this.$store.getters.getObject(this.id)){
        return this.$store.getters.getObject(this.id).data;
      }else {
        return {}
      }
    },
    googleField: function() {
      return this.stepprops.recordFields.find( (v) => { if (v.isGoogleAutocomplete) return true; } );
    },
    disabled: function() {
      return this.$store.getters.getRecordState!="EDIT" && this.$store.getters.getRecordState!="NEW";
    },
    table: function() {
      return this.stepprops.table;
    },
    recordTarget: function() {
      return this.stepprops.recordTarget;
    },
    
  },

  mounted: function() {
      if (this.config && this.config.apiKey) this.googleAutocomplete();
  },

  filters: {
  },

  methods: {
    getFieldValue: function(obj, path) {
      // eslint-disable-next-line no-redeclare
      for (var i=0, path=path.split('.'), len=path.length; i<len; i++){
        if (obj)
        obj = obj[path[i]];
      }
      return obj;
    },
    
    googleAutocomplete: async function() {
      console.log("--> googleAutocomplete")
      console.log('apikey', this.config.apiKey);
      this.loader = await this.$store.dispatch( 'googleMapLoader', { loader: Loader, apiKey: this.config.apiKey } )
      console.log('loader f2!', this.loader);
      
      this.loader.load().then(async () => {
        // eslint-disable-next-line no-undef
        await google.maps.importLibrary("marker");
        // eslint-disable-next-line no-undef
        await google.maps.importLibrary("places");
        
        console.log('google import library done')
        
        console.log('getRecordState', this.$store.getters.getRecordState)
        
        // eslint-disable-next-line no-undef
        const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement();
        placeAutocomplete.id = "place-autocomplete-input";
        const card = document.getElementById(this.id+'isGoogleAutocomplete');
        console.log('card', card)
        card.appendChild(placeAutocomplete);
        console.log('card con appendChild', card)
        
        placeAutocomplete.addEventListener("gmp-select", async ({placePrediction}) => {
          let place = placePrediction.toPlace();
          console.log('gmp-select done')
          await place.fetchFields({
            fields: ["displayName", "formattedAddress", "location", "addressComponents"],
          });
          console.log('place', place)
          
          let gf=this.googleField;
          if (gf) {
            
            for (let f in gf) {
              if (f!='isGoogleAutocomplete' && gf[f]) {
                this.$store.commit('SET_FIELD_VALUE', { fieldname: gf[f], fieldvalue: '' } );
              }
            }
            place.addressComponents.forEach( (c) => {
              if (c.types && c.types.length>0 && gf[c.types[0]]) {
                this.$store.commit('SET_FIELD_VALUE', { fieldname: gf[c.types[0]], fieldvalue: c.longText } );
              } else console.log('Campo non salvato!!!', c.longText, 'type: '+c.types[0] )
            });
            if (gf['latitude'])   this.$store.commit('SET_FIELD_VALUE', { fieldname: gf['latitude'], fieldvalue: place.location.lat() } );
            if (gf['longitude'])  this.$store.commit('SET_FIELD_VALUE', { fieldname: gf['longitude'], fieldvalue: place.location.lng() } );
            
            this.place=place;
          } else console.log('gf vuoto', gf)
          
          console.log('fine placeAutocomplete.addEventListener')
        });
        console.log('fine googleAutocomplete')
      });
    },
    
    bubbleUpChange: function(event) {
      console.log('bubbleUpChange', {...event, recordTarget: this.recordTarget}); 
      this.$emit('bubbleUpChange', {...event, recordTarget: this.recordTarget});
    },
    
    isAdmin(){
      return this.$store.getters.isAdmin;
    }
  }
}
</script>

<style scoped>

</style>
